module.exports = __webpack_public_path__ + "img/hydatos.42078dd1.jpg";